export class CancelYardRequest {

    LicenseKey: string;
    CancelReason: string;

}